<template>
  <LivePreview />
</template>

<script>
import LoadingSkeleton from '@/components/generic/LoadingSkeleton'

const LivePreview = () => ({
  component: import('@/components/center_widgets/LivePreview'),
  loading: LoadingSkeleton,
  timeout: 200,
})

export default {
  name: 'LiveListPage',
  components: { LivePreview },
}
</script>
